export default __webpack_public_path__ + "static/media/logo-large.87a87fb9.webp";